// extracted by mini-css-extract-plugin
export default {"content":"News_content__U86Wc","title":"News_title__0z1WJ","bulletPoint":"News_bulletPoint__wmMtf","video":"News_video__4HT4i"};